import * as constants from "../../../../constants";
import { GetCommentsParams, GetCommentsResult } from "@/components/comment/actions/types";
import environments from "@/environments";

// NOTE: コメント一覧画面のデータを更新するのでホーム画面用のコメント取得はactionsを分ける
// コメント一覧取得
export const getComments = (params: GetCommentsParams, callback?: (res: GetCommentsResult) => void) => {
  const endpoint = `${environments.API_BASE_URI}/comments`;

  const query = new URLSearchParams();
  (params.category_id || []).forEach((id) => query.append("category_id[]", id.toString()));
  (params.primary_charge_id || []).forEach((id) => query.append("primary_charge_id[]", id.toString()));
  (params.area_id || []).forEach((id) => query.append("area_id[]", id.toString()));
  (params.device_id || []).forEach((id) => query.append("device_id[]", id.toString()));
  params.comment && query.set("comment", params.comment);
  params.insert_start_date && query.set("insert_start_date", params.insert_start_date);
  params.insert_end_date && query.set("insert_end_date", params.insert_end_date);
  query.set("start", params.start.toString());
  query.set("limit", params.limit.toString());
  query.set("order", "2"); // 1: コメント一覧用, 2: ホーム画面用

  return {
    type: constants.APP_CALL_API,
    endpoint: `${endpoint}?${query.toString()}`,
    method: "GET",
    callbacks: {
      begin: () => {
        return {
          type: constants.HOME_COMMENT_BEGIN_FETCH,
          payload: params,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.HOME_COMMENT_END_FETCH,
          payload: response,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};
